import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

// Labels and icons distinguish sources without assigning each one a color.
export const getMemoryThemeColors = (theme, colors = {}) => {
  const palette = getCatalogPalette(theme);
  const neutral = { fg: palette.icon, bg: palette.preview, border: palette.border };
  return {
    ...palette,
    accent: palette.icon,
    learned: neutral.fg,
    learnedBg: neutral.bg,
    learnedBorder: neutral.border,

    auto: neutral.fg,
    autoBg: neutral.bg,
    autoBorder: neutral.border,

    explicit: neutral.fg,
    explicitBg: neutral.bg,
    explicitBorder: neutral.border,

    import: neutral.fg,
    importBg: neutral.bg,
    importBorder: neutral.border,

    manual: neutral.fg,
    manualBg: neutral.bg,
    manualBorder: neutral.border,

    neutral,
    success: colors.color_success || '#22C55E',
    warning: '#F59E0B',
  };
};
